import { useEffect } from 'react';
import '../styles/page.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

function License() {
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <>
      <section id="license-banner">
        <div className="page-banner-bg">
          <div className="m-auto page-banner-container">
            <h2 data-aos="fade-right" data-aos-duration="700" data-aos-once="true">
              특허 및 인증
            </h2>
            <p
              className="color-caption fs-md"
              data-aos="fade-right"
              data-aos-duration="700"
              data-aos-once="true"
              data-aos-delay="200"
            >
              TAKE가 보유한 주요 특허와 인증 현황입니다.
            </p>
          </div>
        </div>
      </section>

      <main id="license">
        <div className="m-auto mt-80 license-page">
          <p className="fs-xl fw-bold">특허</p>
          <div className="license-container">
            <div>
              <div className="license-img">
                <img src="./images/license/certificate01.jpg" alt="" />
              </div>
              <p className="fs-base text-center">특허출원</p>
              <p className="fs-sm color-caption text-center mt-8">UXBoosterFramework를 활용한 웹/모바일 통합 표준 자동화 및 최적화 솔루션</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/certificate02.jpg" alt="" />
              </div>
              <p className="fs-base text-center">특허출원</p>
              <p className="fs-sm color-caption text-center mt-8">사용자 중심 UI/UX를 반영한 웹 표준 기반<br /> 통합 개발 플랫폼 및 그 구축 방법</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/certificate03.jpg" alt="" />
              </div>
              <p className="fs-base text-center">특허출원</p>
              <p className="fs-sm color-caption text-center mt-8">AI기반 레거시 시스템<br /> 웹 전환 자동화 시스템</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/certificate04.jpg" alt="" />
              </div>
              <p className="fs-base text-center">특허출원</p>
              <p className="fs-sm color-caption text-center mt-8">업무화면 UI 자동 생성 시스템</p>
            </div>
          </div>
          <p className="fs-xl fw-bold">인증</p>
          <div className="license-container">
            <div>
              <div className="license-img">
                <img src="./images/license/license19.jpg" alt="" />
              </div>
              <p className="fs-base text-center">중소기업확인서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license20.jpg" alt="" />
              </div>
              <p className="fs-base text-center">소프트웨어사업자 신고확인서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license18.jpg" alt="" />
              </div>
              <p className="fs-base text-center">벤쳐기업확인서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license15.jpg" alt="" />
              </div>
              <p className="fs-base text-center">연구개발전담부서 인정서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license14.jpg" alt="" />
              </div>
              <p className="fs-base text-center">소프트웨어프로세스 품질인증서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license01.jpg" alt="" />
              </div>
              <p className="fs-base text-center">소프트웨어산업협회 정회원증</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license08.jpg" alt="" />
              </div>
              <p className="fs-base text-center">벤쳐협회 정회원증</p>
            </div>
          </div>
          <p className="fs-xl fw-bold">협약서</p>

          <div className="license-container">
            <div>
              <div className="license-img">
                <img src="./images/license/license02.jpg" alt="" />
              </div>
              <p className="fs-base text-center">R&D 공동기술개발 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license03.jpg" alt="" />
              </div>
              <p className="fs-base text-center">UI/UX 개발 마케팅 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license04.jpg" alt="" />
              </div>
              <p className="fs-base text-center">글로벌 업무협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license05.jpg" alt="" />
              </div>
              <p className="fs-base text-center">경기 가족회사 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license06.jpg" alt="" />
              </div>
              <p className="fs-base text-center">비즈플래닛 통합 플랫폼 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license07.jpg" alt="" />
              </div>
              <p className="fs-base text-center">K-디지털 트레이닝 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license09.jpg" alt="" />
              </div>
              <p className="fs-base text-center">홍보 마케팅 업무 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license17.jpg" alt="" />
              </div>
              <p className="fs-base text-center">특허기반 R&D 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license10.jpg" alt="" />
              </div>
              <p className="fs-base text-center">국민대학교 산학협력 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license12.jpg" alt="" />
              </div>
              <p className="fs-base text-center">경희대학교 산학협력 협약서</p>
            </div>
            <div>
              <div className="license-img">
                <img src="./images/license/license11.jpg" alt="" />
              </div>
              <p className="fs-base text-center">㈜GIT아카데미 산학협력 체결서</p>
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

export default License;
